import { render } from "./BGAlertsWithIcon.vue?vue&type=template&id=4aca0c43&ts=true"
import script from "./BGAlertsWithIcon.vue?vue&type=script&lang=ts"
export * from "./BGAlertsWithIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__